export default __webpack_public_path__ + "static/logo_var_orange-83d1505a77b5f7d7e02e430d0f1780c5.png";